<template>
  <div>
  </div>
</template>
<script>import { createPopper } from "@popperjs/core";

export default {
  data() {
    return { dropdownPopoverShow: false, };
  }, methods: {
    toggleDropdown: function(event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, { placement: "bottom-start", });
      }
    },
  },
};</script>
